// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
	@media not all and (--mobile) {
    .UqQ6JU55Ui_toytAgffW {
		margin-left: 0;
}
	}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPage/APRValue/APRValue.pcss"],"names":[],"mappings":";CACC;IADD;EAEE,cAAc;AAEhB;CADC","sourcesContent":[".spinner {\n\t@media not all and (--mobile) {\n\t\tmargin-left: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `UqQ6JU55Ui_toytAgffW`
};
export default ___CSS_LOADER_EXPORT___;
